import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_websoft/layout/core'
import ThermoBoardLista from './ThermoBoardLista'
import ThermoBoardDetails from './ThermoBoardDetails'
import ThermoBoardPaketi from './ThermoBoardPaketi'
import ThermoboardIzvjestajPoTipu from './ThermoboardIzvjestajPoTipu'
import ThermoBoardFmkDetails from './ThermoBoardFmkDetails'
import ThermoBoardFmkLista from './ThermoBoardFmkLista'
import OtpremniceDetails from './OtpremniceDetails'
import TherboardObradaPloca from './TherboardObradaPloca'
import ThermoboardObradaPlocaDetais from './ThermoboardObradaPlocaDetais'

const ThermoBoardBreadCrumbs: Array<PageLink> = [
  {
    title: 'ThermoBoard',
    path: '/ThermoBoard/dodaj',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ThermoBoardRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path='interni-nalozi'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>Lista naloga</PageTitle>
              <ThermoBoardLista />
            </>
          }
        />
        <Route
          path='paketi'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>Lista paketa</PageTitle>
              <ThermoBoardPaketi />
            </>
          }
        />
        <Route
          path='dodaj'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>Dodaj</PageTitle>
              <ThermoBoardDetails />
            </>
          }
        />
        <Route
          path='izmjena/:id'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>Izmjena</PageTitle>
              <ThermoBoardDetails />
            </>
          }
        />
        <Route
          path='izvjestaj'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>Izvjestaj</PageTitle>
              <ThermoboardIzvjestajPoTipu />
            </>
          }
        />
        <Route
          path='fmk-nalozi'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>FMK Nalozi</PageTitle>
              <ThermoBoardFmkLista />
            </>
          }
        />
        <Route
          path='fmk-nalozi/dodaj'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>FMK Nalozi</PageTitle>
              <ThermoBoardFmkDetails />
            </>
          }
        />
        <Route
          path='fmk-nalozi/izmjena/:id'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>FMK Nalozi</PageTitle>
              <ThermoBoardFmkDetails />
            </>
          }
        />
        <Route
          path='otpremnice'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>Otpremnice</PageTitle>
              <OtpremniceDetails />
            </>
          }
        />
        <Route
          path='obrada-ploca'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>Obrada ploča</PageTitle>
              <TherboardObradaPloca />
            </>
          }
        />
        <Route
          path='obrada-ploca/izmjena/:id'
          element={
            <>
              <PageTitle breadcrumbs={ThermoBoardBreadCrumbs}>Izmjena obrade ploča</PageTitle>
              <ThermoboardObradaPlocaDetais />
            </>
          }
        />
        <Route index element={<Navigate to='/thermoboard/Lista' />} />
      </Route>
    </Routes>
  )
}

export default ThermoBoardRoutes
